import { Card, CardBody, CardTitle, Col, FormGroup, Label, Row } from "reactstrap";
import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { AvField, AvForm } from "availity-reactstrap-validation";
import CustomSelect from "../../../../../components/Common/CustomSelect";

const OfferTrackerProfileBlock = (props) => {
  const { data, updateTrackerOfferProfile, history, trackerId, offerId, trackerData } = props;

  const [isFormSubmit, setIsFormSubmit] = useState(null);
  const [platformSelect, setPlatformSelect] = useState(null);

  const trackingPlatform = [{label: "ADJUST", value: "adjust"}, {label: "APPSFLYER", value: "appsflyer"}];

  const  getDefaultValue = (item) => {
    return {label: item, value: item?.toLowerCase()};
  }

  const handleValidOrderSubmit = (e, errors, params) => {
    setIsFormSubmit(true);
    if (errors?.length === 0) {
      const tracker = {
        trackingLink: params["tracking_link"],
        trackingPlatform: params?.platform.label,
        offer: offerId,
      };
      updateTrackerOfferProfile(trackerId, tracker, trackerData);
    }
    history.goBack();
  };

  return (
    <Row>
      <Col lg={12}>
        <Card>
          <CardBody>
            <CardTitle>Offer tracker profile</CardTitle>
            <AvForm className="needs-validation" onSubmit={handleValidOrderSubmit}>
              <Row className="mt-2" >
                <Col lg={6}>
                  <div className="mt-4">
                    <Label>Tracking link</Label>
                    <AvField
                      name="tracking_link"
                      type="url"
                      value={data?.tracking_link ? data?.tracking_link : ''}
                      errorMessage="This value should be a valid url."
                      validate={{
                        required: { value: true },
                      }}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mt-4">
                    <Label>Tracking platform</Label>
                    <FormGroup>
                      <CustomSelect
                        name="platform"
                        value={platformSelect}
                        defaultValue={data?.tracking_platform ? getDefaultValue(data?.tracking_platform) : 'Suka'}
                        options={trackingPlatform}
                        placeholder="Select tracking platform..."
                        classNamePrefix="select2-selection"
                        errorMessage="Tracking platform field is required"
                        onChange={setPlatformSelect}
                        required
                        isFormSubmit={isFormSubmit}
                      />
                    </FormGroup>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <ButtonContainer>
                    <button type="submit" className="btn btn-success save-user">
                      Save changes
                    </button>
                  </ButtonContainer>
                </Col>
              </Row>
            </AvForm>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

OfferTrackerProfileBlock.propTypes = {
  data: PropTypes.any,
  trackerData: PropTypes.any,
  updateTrackerOfferProfile: PropTypes.func,
  trackerId: PropTypes.any,
  offerId: PropTypes.any,
  history: PropTypes.any,
};

const ButtonContainer = styled.div`
  padding-top: 30px;
  text-align: right !important;
`;

export default OfferTrackerProfileBlock;